import * as React from "react";
import {
  TableHead,
  TableRow,
  Theme,
  WithStyles
} from "@material-ui/core";
import ICommunityMembership from "../types/ICommunityMembership";
import { RouteComponentProps } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography/Typography";
import BreadCrumb from "../../shared/components/BreadCrumb";
import IMembershipHistoryItem from "../types/IMembershipHistoryItem";
import { getCommunityMembershipHistory } from "../api/communitiesApi";
import { Table, TableBody, TableCell } from "@material-ui/core/";
import DateHelper from "../../shared/helpers/DateHelper";
import Loading from "../../shared/components/loading/Loading";

const styles = (theme: Theme) => ({
  table: {
    marginTop: theme.spacing.unit * 3,
  }
});

interface IState {
  membership: ICommunityMembership | null,
  isLoading: boolean;
  historyItems: IMembershipHistoryItem[]
}

interface IProps extends WithStyles<typeof styles>, RouteComponentProps<any> {

}

class CommunityManagementMembershipDetailsHistory extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    const membership = this.props.location.state ? this.props.location.state.membership : null;
    this.state = {
      isLoading: true,
      membership,
      historyItems: []
    }
    if (membership) {
      this.loadMembershipHistory();
    } else {
      this.redirectToMembershipsOverview();
    }
  }

  public async loadMembershipHistory() {
    if (this.state && this.state.membership) {
      const membershipHistory = await getCommunityMembershipHistory(this.state.membership.communityCode, this.state.membership.id)
      this.setState({
        historyItems: membershipHistory,
        isLoading: false
      });
    }
  }

  public redirectToMembershipsOverview() {
    this.props.history.push({
      pathname: `/community-management/${this.props.match.params.communityCode}/memberships`
    })
  }

  public render() {
    const { classes } = this.props;
    const { membership, historyItems, isLoading } = this.state;

    return (
      <>
        <Typography variant="title">{membership && `${membership.communityName} | `}Membership history</Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb value="Console" to="/"/>
          <BreadCrumb value="Community management" to="/community-management"/>
          <BreadCrumb value="Memberships overview"
                      to={`/community-management/${this.props.match.params.communityCode}/memberships`}/>
          <BreadCrumb value={this.props.match.params.nxtEntityId}
                      to={`/community-management/${this.props.match.params.communityCode}/memberships/${this.props.match.params.nxtEntityId}`}/>
          History
        </Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Original status</TableCell>
              <TableCell>New status</TableCell>
              <TableCell>Performed by</TableCell>
              <TableCell/>
              <TableCell/>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && <TableRow>
              <TableCell><Loading/></TableCell>
            </TableRow>}
            
            {!isLoading && historyItems.map((historyItem: IMembershipHistoryItem) =>
              (
                <TableRow key={historyItem.id}>
                  <TableCell>{DateHelper.FormatDate(historyItem.updatedOn)}</TableCell>
                  <TableCell>{historyItem.oldStatus}</TableCell>
                  <TableCell>{historyItem.newStatus}</TableCell>
                  <TableCell>{historyItem.callerEntityName}</TableCell>
                  <TableCell/>
                  <TableCell/>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </>
    )
  }
}


export default withStyles(styles)(CommunityManagementMembershipDetailsHistory)




// WEBPACK FOOTER //
// ./src/modules/communities/components/CommunityManagementMembershipDetailsHistory.tsx